import * as React from "react";

// Mui
import Box from "@mui/material/Box";
import { darken, lighten, styled } from "@mui/material/styles";
import { DataGrid, GridPagination, GridToolbar } from "@mui/x-data-grid";

// Compoents
import { EscapeRegExp } from "@/components/DataTable/searchingBar";
export default function DataTable(props) {
  const {
    ariaLabel = "",
    ariaLabelledby = "",
    rows,
    columns,
    productData,
    onCellClick = () => {},
    onRowClick = () => {},
    disableExportButton = true,
    Toolbar = GridToolbar,
    Footer = GridPagination,
    checkboxSelection,
    productSelecter = false,
    searchFeild = [],
    initialState,
    pageSize = 25,
    onCellEditCommit,
    hideFooter,
    getRowId,
    onPageChange,
    page,
    isCellEditable,
    disableColumnMenu = false,
    disableColumnSelector = false,
    disableColumnFilter = false,
    editedCell,
    searchBarPlaceholder = "搜索",
    newEditingApi,
    onSelectionModelChange,
    pinFirstColumn = false,
    fetchData,
    noRowsLabel = "沒有資料",
    handleImport = () => {},
    handleImportShop = () => {},
    handleImportProduct = () => {},
    getRowClassName = () => {},
    loading = true,
    apiRef,
    promotionTargetData = [],
    amOptions = [],
  } = props;
  // States
  const [rowsData, setRowsData] = React.useState([]);
  const [showMode, setShowMode] = React.useState("qty");
  const [sortModel, setSortModel] = React.useState([]);

  const [searchText, setSearchText] = React.useState("");
  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(EscapeRegExp(searchValue), "i");
    const filteredRows = rows?.filter((row) => {
      if (searchFeild.length > 0) {
        return searchFeild.some((field) => {
          return searchRegex.test(row[field]?.toString());
        });
      } else {
        return Object.keys(row).some((field) => {
          return searchRegex.test(row[field]?.toString());
        });
      }
    });
    setRowsData(filteredRows);
  };
  React.useEffect(() => {
    const findVirtualScroller = () => {
      const virtualScrollerElement = document.querySelector(
        ".MuiDataGrid-virtualScroller",
      );
      if (!virtualScrollerElement) {
        setTimeout(findVirtualScroller, 100);
      } else {
        virtualScrollerElement.addEventListener(
          "scroll",
          handleScrollHorizontal,
        );
        return () => {
          virtualScrollerElement.removeEventListener(
            "scroll",
            handleScrollHorizontal,
          );
        };
      }
    };
    if (pinFirstColumn) {
      findVirtualScroller();
    }
  }, [pinFirstColumn]);
  const getBackgroundColor = (color, theme, coefficient) => ({
    backgroundColor: darken(color, coefficient),
    ...theme.applyStyles("light", {
      backgroundColor: lighten(color, coefficient),
    }),
  });
  const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    "& .distributionTable--Selected": {
      ...getBackgroundColor(theme.palette.warning.main, theme, 0.7),
      "&:hover": {
        ...getBackgroundColor(theme.palette.warning.main, theme, 0.6),
      },
      "&.Mui-selected": {
        ...getBackgroundColor(theme.palette.warning.main, theme, 0.5),
        "&:hover": {
          ...getBackgroundColor(theme.palette.warning.main, theme, 0.4),
        },
      },
    },
  }));
  const commonStyle = {
    "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer":
      {
        display: "none",
      },
  };
  const nonPinFirstColumnStyle = {
    "& .MuiDataGrid-cell": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    ".MuiDataGrid-virtualScroller": {
      height: "500px !important",
      overflowY: "scroll !important",
    },
  };
  const pinFirstColumnStyle = {
    "& .MuiDataGrid-columnHeaders": {
      "& .MuiDataGrid-columnHeadersInner": {
        transform: "none !important",
        "& div": {
          "& .MuiDataGrid-columnHeader:nth-child(2)": {
            backgroundColor: "#FFFFFF",
            zIndex: 2,
          },
        },
      },
    },
    ".MuiDataGrid-virtualScroller": {
      height: "400px !important",
      overflowY: "scroll !important",
      scrollbarWidth: "thin !important",
    },
    "& .MuiDataGrid-cell:nth-child(2)": {
      position: "sticky",
      top: "0",
      left: "0",
      paddingLeft: "1.5rem",
      zIndex: 999,
      backgroundColor: "#FFFFFF !important",
    },
    "& .MuiDataGrid-columnHeader:nth-child(2)": {
      backgroundColor: "#FFFFFF !important",
      position: "sticky",
      top: "0",
      left: "0",
      paddingLeft: "1.5rem",
      border: "none",
      zIndex: 999,
    },
  };
  const source_color = "rgba(243, 255, 168, 0.74)";
  const compare_color = "rgba(180, 219, 221, 0.74)";

  const handleScrollHorizontal = () => {
    const currentScrollPos = document.querySelector(
      ".MuiDataGrid-virtualScroller",
    ).scrollLeft;
    const columnsHeaders = document.querySelectorAll(
      ".MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader:nth-child(2))",
    );
    columnsHeaders.forEach((columnHeader) => {
      columnHeader.style.transform = `translate3d(-${currentScrollPos}px, 0px, 0px)`;
    });
  };

  React.useEffect(() => {
    //set condition to restrict All data fetching
    setRowsData(rows);
    //requestSearch(searchText);
  }, [rows]);

  const dataTable = React.useMemo(
    () => (
      <StyledDataGrid
        {...props}
        experimentalFeatures={{
          newEditingApi: newEditingApi ? newEditingApi : false,
        }}
        id={ariaLabel}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledby}
        // sortModel={sortModel}
        // onSortModelChange={(newSortModel) => {
        //   setSortModel(newSortModel);
        // }}
        isCellEditable={isCellEditable && isCellEditable}
        initialState={{
          ...initialState,
          pagination: { paginationModel: { pageSize } },
        }}
        onPageChange={onPageChange && onPageChange}
        page={page && page}
        getRowId={getRowId}
        onCellClick={(params) => {
          onCellClick(params);
        }}
        apiRef={apiRef}
        onCellEditCommit={onCellEditCommit}
        onSelectionModelChange={onSelectionModelChange}
        rows={rowsData}
        columns={columns}
        checkboxSelection={checkboxSelection}
        disableSelectionOnClick
        disableColumnMenu={disableColumnMenu}
        disableColumnSelector={disableColumnSelector}
        disableColumnFilter={disableColumnFilter}
        getCellClassName={(params) => {
          if (editedCell?.[`${params.id}:${params.field}`] === true) {
            return "edited";
          }
          return "";
        }}
        getRowClassName={getRowClassName}
        hideFooter={hideFooter ? hideFooter : false}
        slots={{
          toolbar: Toolbar,
          footer: Footer,
        }}
        loading={loading}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "skeleton",
          },
          toolbar: {
            printOptions: { disableToolbarButton: disableExportButton },
            csvOptions: {
              utf8WithBom: true,
              disableToolbarButton: disableExportButton,
            },
            promotionTargetData,
            amOptions,
            productData,
            rows: rows,
            productSelecter: productSelecter,
            handleImportShop: handleImportShop,
            handleImportProduct: handleImportProduct,
            handleImport: handleImport,
            value: searchText,
            onChange: (event) => requestSearch(event.target.value),
            clearSearch: () => requestSearch(""),
            placeholder: searchBarPlaceholder,
            fetchData: fetchData,
            loading: loading,
            showMode: showMode,
            setShowMode: setShowMode,
          },
          footer: {
            rowsdata: rowsData,
            showmode: showMode,
          },
        }}
        onRowClick={(params) => {
          onRowClick(params);
        }}
        sx={
          pinFirstColumn
            ? pinFirstColumnStyle
            : { ...nonPinFirstColumnStyle, ...props.sx, ...commonStyle }
        }
        localeText={{
          noRowsLabel: noRowsLabel,
          footerRowSelected: (count) =>
            count !== 1
              ? `已選擇 ${count.toLocaleString()} 項資料`
              : `已選擇 ${count.toLocaleString()} 項資料`,
        }}
      />
    ),
    [rowsData, loading, productData, sortModel],
  );
  return (
    <Box
      component="div"
      sx={{
        width: "100%",
        overflow: "auto",
        "& .edited": {
          backgroundColor: "yellow",
        },
        "& .comparison--1": {
          backgroundColor: source_color,
        },
        "& .comparison--2": {
          backgroundColor: compare_color,
        },
        "& .date--header": {
          alignItems: "flex-end",
          backgroundColor: "rgba(255, 7, 0, 0.55)",
        },
        "& .negative--cell": {
          color: "red",
        },
        "& .positive--cell": {
          color: "green",
        },
        "& .bold--cell": {
          fontWeight: "bold",
        },
      }}
    >
      {dataTable}
    </Box>
  );
}
